"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-unused-vars */

// Aliases to all weights that the application
// loads for the Lato typeface:
var thin = 100;
var light = 300;
var regular = 400;
var semibold = 600;
var bold = 700;
var fontHeight = function fontHeight(fontSize, lineHeight, otherFontProps) {
  return _objectSpread({
    fontSize: "".concat(fontSize, "px"),
    fontWeight: regular,
    lineHeight: typeof lineHeight === 'number' ? lineHeight / fontSize : lineHeight
  }, otherFontProps);
};
var basicTypeface = fontHeight(16, 19);
var smallTypeface = fontHeight(12, 15);
var typefaces = {
  basic: basicTypeface,
  small: smallTypeface,
  guideCard: {
    title: fontHeight(24, 29),
    smallTitle: fontHeight(16, 24),
    subtitle: fontHeight(14, 17)
  },
  guideDetails: {
    title: fontHeight(24, 29, {
      fontWeight: light
    }),
    slug: fontHeight(18, 22, {
      fontWeight: light
    }),
    summary: basicTypeface
  },
  instructionDetails: {
    title: fontHeight(24, 29, {
      fontWeight: light
    }),
    slug: _objectSpread(_objectSpread({}, basicTypeface), {}, {
      fontWeight: light
    })
  },
  modal: {
    title: _objectSpread(_objectSpread({}, basicTypeface), {}, {
      fontWeight: semibold
    })
  },
  newStepLink: {
    title: fontHeight(24, 29)
  },
  sidebar: {
    title: fontHeight(32, 39),
    subtitle: smallTypeface,
    item: basicTypeface,
    overviewLink: fontHeight(15, 18)
  },
  table: {
    bodyCell: fontHeight(14, '20px', {
      fontWeight: 'inherit'
    }),
    xHeaderCell: fontHeight(16, '222px', {
      fontWeight: 'inherit'
    }),
    yHeaderCell: fontHeight(8, '40px', {
      fontWeight: 'inherit',
      textTransform: 'uppercase'
    })
  },
  topicCard: {
    title: fontHeight(26, 31),
    slug: fontHeight(14, 17),
    message: fontHeight(18, 22)
  },
  translations: {
    title: fontHeight(24, 29)
  }
};
var _default = exports["default"] = typefaces;
//# sourceMappingURL=typefaces.js.map